<template>
    <span>
        <li
            v-if="label == 'NO_RESULTS'"
            :class="{'hide': !show}"
            class="no-results">
            No matching data</li>
        <li
            v-else
            :ref="value"
            :class="{'selected': isSelected, 'hide': !isShown, 'multiple': AppSelect.multiple, 'hover': isHover}"
            @click="handleClick"
            @mousedown.prevent.stop=""
            @mouseenter="handleMouseEnter">
            {{ label }}</li>
    </span>
</template>

<script>
import emitter from '@/utilities/emitter'

export default {
    name: 'app-option',
    mixins: [emitter],
    inject: ['AppSelect'],
    props: {
        label: null,
        value: null,
        show: Boolean
    },
    computed: {
        isSelected() {
            if (!this.AppSelect.multiple)
                return this.AppSelect.selected.value === this.value
            else {
                return this.AppSelect.selected.map(el => el.value).indexOf(this.value) > -1
            }
        },
        isShown() {
            return this.AppSelect.options.some(el=>el.value == this.value)
        },
        isHover() {
            if (this.AppSelect.hoveredOption !== undefined)
                return this.AppSelect.hoveredOption.value === this.value
        },
        optionObj() {
            return {'label': this.label, 'value': this.value}
        }
    },
    created() {
        this.AppSelect.options.push(this.optionObj)
        this.AppSelect.vueOptions.push(this)
        this.AppSelect.cachedOptions.push(this.optionObj);
        this.AppSelect.optionsCount++;
    },
    methods: {
        handleClick() {
            this.AppSelect.handleSelectOption(this.optionObj)
            this.AppSelect.useAccessibility = false
            if (!this.AppSelect.multiple) {
                this.AppSelect.isOpen = false
            }
            else {
                this.$nextTick( ()=> {
                    this.AppSelect.$refs.input.focus()
                })
            }
            
        },
        handleMousedown() {

        },
        handleMouseEnter() {
            this.AppSelect.setHoveredIndex(this.optionObj)
        }
    },
}
</script>

<style lang="stylus" scoped>
    li
        font-size: 14px
        padding: 0 20px
        position: relative
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        color: #606266
        height: 34px
        line-height: 34px
        box-sizing: border-box
        cursor: pointer
        &.selected.multiple
            background: white
            &:after
                position: absolute
                right: 20px
                font-family: "spotter"
                content: "\61"
                font-size: 12px
                font-weight: 700
                -webkit-font-smoothing: antialiased
                -moz-osx-font-smoothing: grayscale
            &.hover,
            &:hover
                background: #f7f8fa
        &.selected
            background: #f7f8fa
            border-left: 3px solid #0d5bdb
            color: #0d5bdb
            letter-spacing: 0.5px
            font-weight: 600
        &.hide
            display: none
    
        &.no-results
            margin: 0
            text-align: center
            color: #999
            font-size: 14px
            cursor: text
            &:hover
                background-color: white
</style>
